import { useState, useEffect, useRef, useCallback } from 'react';

export const useWebSocket = (url) => {
  const [socket, setSocket] = useState(null);
  const [isConnected, setIsConnected] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [systemStats, setSystemStats] = useState({});
  const reconnectTimeoutRef = useRef(null);
  const reconnectAttempts = useRef(0);
  const maxReconnectAttempts = 5;

  const connect = useCallback(() => {
    try {
      const access = localStorage.getItem('access_token');
      const ws = new WebSocket(`${url}?token=${access}`);
      
      ws.onopen = () => {
        console.log('WebSocket connected');
        setIsConnected(true);
        setSocket(ws);
        reconnectAttempts.current = 0;
      };

      ws.onmessage = (event) => {
        const data = JSON.parse(event.data);
        
        switch (data.type) {
          case 'pdf_completed':
            setNotifications(prev => [{
              id: Date.now(),
              type: 'success',
              title: 'PDF Completato',
              message: `${data.document_name} creato con successo`,
              documentId: data.document_id,
              downloadUrl: data.download_url
            }, ...prev].slice(0, 1)); // Mantieni solo l'ultima notifica
            
            // Notifica browser se supportata
            // if ('Notification' in window && Notification.permission === 'granted') {
            //   new Notification('PDF Completato', {
            //     body: `${data.document_name} è stato generato`,
            //     icon: '/pdf-icon.png'
            //   });
            // }
            break;
            
          case 'pdf_error':
            setNotifications(prev => [{
              id: Date.now(),
              type: 'error',
              title: 'Errore Generazione PDF',
              message: data.error_message,
              documentId: data.document_id
            }, ...prev].slice(0, 50));
            break;
            
          default:
            console.log('Unknown message type:', data.type);
        }
      };

      ws.onclose = (event) => {
        console.log('WebSocket closed:', event.code, event.reason);
        setIsConnected(false);
        setSocket(null);
        
        // Riconnessione automatica
        if (reconnectAttempts.current < maxReconnectAttempts) {
          const delay = Math.min(1000 * Math.pow(2, reconnectAttempts.current), 30000);
          reconnectTimeoutRef.current = setTimeout(() => {
            reconnectAttempts.current++;
            connect();
          }, delay);
        }
      };

      ws.onerror = (error) => {
        console.error('WebSocket error:', error);
      };

    } catch (error) {
      console.error('Failed to create WebSocket:', error);
    }
  }, [url]);

  useEffect(() => {
    connect();
    
    return () => {
      if (reconnectTimeoutRef.current) {
        clearTimeout(reconnectTimeoutRef.current);
      }
      if (socket) {
        socket.close();
      }
    };
  }, [connect]);

  const clearNotifications = useCallback(() => {
    setNotifications([]);
  }, []);

  const removeNotification = useCallback((id) => {
    setNotifications(prev => prev.filter(notif => notif.id !== id));
  }, []);

  return {
    socket,
    isConnected,
    notifications,
    systemStats,
    clearNotifications,
    removeNotification
  };
};